import { Col, Pagination as Page } from "antd";
import React, { useState } from "react";

const Pagination = (props) => {
  const [currentPage, setCurrentPage] = useState(1);
  const setPage = (page) => {
    setCurrentPage(page);
    props.getPage(page);
  };

  return (
    <Col>
      <Page
        data-testid="paginate"
        defaultPageSize={props.pageSize ? props.pageSize : 10}
        current={currentPage}
        total={props.totalJobs}
        onChange={setPage}
        showSizeChanger={false}
      ></Page>
    </Col>
  );
};

export default Pagination;
